import { Spinner } from "@fluentui/react-components";
import { SearchRegular, WarningRegular } from "@fluentui/react-icons";

export function PageState({ loading, error, title, children, action }) {
    return (
        <div className={`page-state${error ? " page-state--error" : ""}`} role={error ? "alert" : "status"}>
            {loading ? <Spinner label={title} /> : (
                <>
                    <span className="page-state-icon">{error ? <WarningRegular /> : <SearchRegular />}</span>
                    <h2>{title}</h2>
                    {children && <p>{children}</p>}
                    {action}
                </>
            )}
        </div>
    );
}
